export default "/images/logo-dark.png?909b7b25cac5283cd6d503c561bb2b05";